'use client'

import { getLinkRel, isExternalUrl } from '@/lib/utils/link-utils'
import { Illustration } from '@/ui/illustrations/illustration/Illustration'
import type { FooterSocialProps } from './Footer.schema'

import { Link } from '@/ui/links/link/Link.client'

type FooterSocialComponentProps = {
  social: FooterSocialProps
}

export function FooterSocial({ social }: FooterSocialComponentProps) {
  return (
    <div className="flex flex-col gap-2">
      <p className="font-bold">{social.title}</p>
      <div className="flex items-center gap-1">
        {social.links.map(({ alt, icon, url }) => (
          <Link
            variant="free"
            key={`${url}-${icon}`}
            href={url}
            className="flex size-5 items-center justify-center rounded-full bg-white !p-0"
            opensInNewTab={isExternalUrl(url)}
            rel={getLinkRel(url)}
          >
            <Illustration name={icon} className="text-sm text-brand-2-900" />
            <span className="sr-only">{alt}</span>
          </Link>
        ))}
      </div>
    </div>
  )
}
